import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import MultiStepForm from '../../../components/wizard/multiStepForm';
import PlanDetails from './planDetails';
import PaymentDetails from './paymentDetails';
import { saveUserPlan } from '../../../apis/plansApi';
import { openNotification } from "../../../components/notifications";
import { useNavigate } from 'react-router-dom';

const LoadPlan = () => {
  const navigate = useNavigate();

  const steps = [
    { title: "Pago", component: PaymentDetails },
    { title: "Plan", component: PlanDetails },
  ];

  const onSubmit = async (formData) => {
    //TODO load branch
    const updatedFormData = { ...formData, branch: 1, is_petty_cash: 1 };
    const result = await saveUserPlan(updatedFormData)
    if (result.success) {
      localStorage.setItem("notification", JSON.stringify({
        type: "success",
        title: "Plan cargado exitosamente",
        description: "Tu plan se ha guardado exitosamente."
      }));
      navigate(0);
    } else {
      openNotification(
        "error",
        "Error al guardar el plan",
        "Hubo un problema al intentar guardar tu plan. Por favor, inténtalo de nuevo."
      );
    }
  }

  return (
    <MultiStepForm className='themed-block p-5' steps={steps} onSubmit={onSubmit} />
  )
};

export default LoadPlan;
